import CASL from '@/utils/constants/casl'

export default {
  path: 'delivery',
  children: [
    {
      path: '',
      name: 'delivery.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DELIVERY
      },
      component: () => import('./list/DeliveryListPage.vue')
    }
  ]
}
